export default "__VITE_ASSET__XH$IJjI0__"